module.exports = __webpack_public_path__ + "img/1464410461.1de5a25c.jpg";